import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { nominationAPI, STATUS_TONE } from '../../lib/atoNominationAPI';
import { auDate } from '../../lib/complianceAutoAPI';

export const NominationComplianceCard = ({ clientId }) => {
  const nav = useNavigate();
  const [s, setS] = useState(null);
  useEffect(() => { nominationAPI.complianceSummary(clientId).then(setS).catch(() => setS(null)); }, [clientId]);
  if (!s || (clientId && !s.awaiting_authorisation)) return null;
  return (
    <Card className="mb-4" data-testid={clientId ? 'client-compliance-nomination-card' : 'ca-nomination-card'}><CardContent className="p-4 space-y-2">
      <div className="flex flex-wrap items-center gap-4">
        <div className="font-semibold">ATO agent authorisation</div>
        <div><span className="text-2xl font-bold" data-testid="ca-nom-awaiting">{s.awaiting_authorisation}</span> <span className="text-xs text-muted-foreground">entities awaiting authorisation</span></div>
        <div><span className={`text-2xl font-bold ${s.expiring_7 ? 'text-red-600' : ''}`} data-testid="ca-nom-expiring">{s.expiring_7}</span> <span className="text-xs text-muted-foreground">nominations expiring ≤ 7 days</span></div>
        {!clientId && <Button size="sm" variant="outline" className="ml-auto" onClick={() => nav('/new-clients?nomination=action')} data-testid="ca-nom-open">Open nominations</Button>}
      </div>
      <p className="text-xs text-muted-foreground">BAS / IAS / income-tax agent concessions show “Verification Required” until the entity’s nomination is Linked; linking sets “registered agent assigned” automatically (manual confirmations are never overridden).</p>
      {clientId && <div className="flex flex-wrap gap-2">{s.items.map((x) => <Badge key={x.id} className={STATUS_TONE[x.status]} data-testid={`client-compliance-nom-${x.id}`}>{x.client_name}: {x.status_label}{x.expiry_date ? ` · exp ${auDate(x.expiry_date)}` : ''}</Badge>)}</div>}
    </CardContent></Card>
  );
};
